import Vue from 'vue';
import App from './App.vue';
import router from './utils/router';
import { tRoutePlugin } from '@/utils/plugins/i18nRoutes';
import googleTagManagerPlugin from '@/utils/plugins/googleTagManager';
import store from './store';
import i18n from './i18n';
import registerIconComponents from '@/components/utils/icons/index';
import registerIntersectionObserverDirective from '@/utils/directives/IntersectionObserver';
import { MediaQueryManager } from '@/utils/services/mediaQueryManager';
import { LocalStorageStateManager } from '@/utils/services/localStorageStateManager';
import globalAxios from 'axios';
import { ErrorHandler } from './utils/services/errorHandler';

// Polyfills
import 'scroll-behavior-polyfill';

// Import global styling (like reset.scss, font-faces etc.)
import './scss/global.scss';

// Array of global vue directives
[registerIntersectionObserverDirective].forEach(register => register(Vue));

Vue.config.productionTip = false;

// Global axios interceptors
Vue.config.errorHandler = ErrorHandler.instance.handleError;
globalAxios.interceptors.request.use(config => {
  store.dispatch('configuration/setApiLoading', true);
  return config;
});

globalAxios.interceptors.response.use(
  response => {
    store.dispatch('configuration/setApiLoading', false);
    return response;
  },
  error => {
    store.dispatch('configuration/setApiLoading', false);
    return ErrorHandler.instance.handleError(error);
  }
);

Vue.use(registerIconComponents);

// register new vue instance function to translate route names
Vue.use(tRoutePlugin);
Vue.use(googleTagManagerPlugin, {
  router,
  store
});

// Service to detect current MediaQuery
new MediaQueryManager(store);
store.dispatch('app/updateLocale', {
  locale: localStorage.getItem('locale') ?? (navigator.language.substr(0, 2) === 'de' ? 'de-DE' : 'en-GB'),
  isInitial: true
});

// Initialize service which synchronizes Vuex with LocalStorage
new LocalStorageStateManager(store);

// TODO: make typings work to avoid any cast
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(document as any).fonts.onloadingdone = () => store.dispatch('app/updateFontsLoaded');

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
